var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-ancestor is-parent" }, [
    _c("div", { staticClass: "tile" }, [
      _c("div", { staticClass: "tile is-parent is-half" }, [
        _c("article", { staticClass: "tile is-child box" }, [
          _c("div", { staticClass: "columns is-gapless" }, [
            _c("div", { staticClass: "column" }, [
              _c("p", { staticClass: "title" }, [
                _vm._v("Detail Info "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.entity.isNew,
                        expression: "!entity.isNew",
                      },
                    ],
                    staticClass: "icon has-text-info tooltip is-tooltip-info",
                    class: [_vm.canChangeReadOnly ? "readonly-pointer" : ""],
                    attrs: {
                      "data-tooltip": _vm.readOnlyView
                        ? "Invoice is locked"
                        : "Invoice is unlocked",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.toogleReadOnly()
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "icon mdi",
                      class: [
                        _vm.readOnlyView
                          ? "mdi-lock-outline"
                          : "mdi-lock-open-outline",
                      ],
                    }),
                  ]
                ),
              ]),
              _vm.isGstPaid
                ? _c("p", { staticClass: "subtitle has-text-warning" }, [
                    _vm._v("Invoice cannot be updated"),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "column is-narrow" }, [
              _vm.isGstPaid
                ? _c(
                    "span",
                    { staticClass: "tag is-warning is-pulled-right" },
                    [
                      _vm._v(
                        " GST paid on " +
                          _vm._s(
                            _vm.$filters.formatDateTimezone(
                              _vm.entity.gstPaidDate,
                              _vm.$userInfo.locale
                            )
                          )
                      ),
                    ]
                  )
                : _vm._e(),
              _c("span", { staticClass: "is-pulled-right" }, [_vm._v(" ")]),
              _vm.entity.isFullyPaid
                ? _c(
                    "span",
                    { staticClass: "tag is-warning is-pulled-right" },
                    [_vm._v(" Fully Paid ")]
                  )
                : _vm._e(),
            ]),
          ]),
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Invoice No.")]),
              !_vm.entity.isNew && !_vm.readOnly
                ? _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.entity.invoiceRef,
                          expression: "entity.invoiceRef",
                        },
                      ],
                      staticClass: "input is-static",
                      attrs: {
                        type: "text",
                        placeholder: "Invoice No.",
                        readonly: "",
                      },
                      domProps: { value: _vm.entity.invoiceRef },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.entity,
                            "invoiceRef",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ])
                : _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.entity.invoiceRef,
                          expression: "entity.invoiceRef",
                        },
                        {
                          name: "fq-validate",
                          rawName: "v-fq-validate",
                          value: _vm.$v.entity.invoiceRef,
                          expression: "$v.entity.invoiceRef",
                        },
                      ],
                      ref: "name",
                      staticClass: "input is-capitalized",
                      class: { "is-static": !_vm.isNew || _vm.readOnly },
                      attrs: { readonly: _vm.readOnly, type: "text" },
                      domProps: { value: _vm.entity.invoiceRef },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.entity,
                            "invoiceRef",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    !_vm.$v.entity.invoiceRef.required && !_vm.readOnly
                      ? _c("span", { staticClass: "help is-danger" }, [
                          _vm._v(" Invoice number is required "),
                        ])
                      : _vm._e(),
                    !_vm.$v.entity.invoiceRef.isValid && !_vm.readOnly
                      ? _c("span", { staticClass: "help is-danger" }, [
                          _vm._v(" Invoice number already in use "),
                        ])
                      : _vm._e(),
                  ]),
            ]),
            _c("div", { staticClass: "column is-narrow" }, [
              _vm.readOnly
                ? _c("div", { staticClass: "field" }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("Invoice Date"),
                    ]),
                    _c("div", { staticClass: "control" }, [
                      _c("input", {
                        staticClass: "input is-static",
                        attrs: { readonly: "" },
                        domProps: {
                          value: _vm.$filters.formatDateTimezone(
                            _vm.entity.invoiceDate,
                            _vm.$userInfo.locale
                          ),
                        },
                      }),
                    ]),
                  ])
                : _vm.$userInfo && !_vm.readOnly
                ? _c(
                    "div",
                    { staticClass: "field is-narrow" },
                    [
                      _c("label", { staticClass: "label" }, [
                        _vm._v("Invoice Date"),
                      ]),
                      _c("v-date-picker", {
                        attrs: {
                          "is-dark": _vm.$theme.isDark,
                          masks: _vm.formats,
                          attributes: _vm.attrs,
                          locale: _vm.$userInfo.locale,
                          "min-date": _vm.firstDayOfMonth,
                          timezone: _vm.$filters.getIanaTimezone(),
                        },
                        on: {
                          input: function ($event) {
                            _vm.selectedInvoiceDate = $event
                              ? _vm.$filters.fromISOWithCurrentTime(
                                  $event.toISOString()
                                )
                              : null
                          },
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ inputValue, inputEvents }) {
                              return [
                                _c("div", { staticClass: "field" }, [
                                  _c(
                                    "div",
                                    { staticClass: "control has-icons-left" },
                                    [
                                      _c(
                                        "input",
                                        _vm._g(
                                          {
                                            staticClass: "input",
                                            attrs: {
                                              type: "text",
                                              placeholder: "Date To...",
                                              readonly: "",
                                            },
                                            domProps: { value: inputValue },
                                          },
                                          inputEvents
                                        )
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "icon is-small is-left",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "mdi mdi-calendar mdi-18px",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.selectedInvoiceDate,
                          callback: function ($$v) {
                            _vm.selectedInvoiceDate = $$v
                          },
                          expression: "selectedInvoiceDate",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]),
          _c("div", { staticClass: "is-divider" }),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Vendor")]),
            _c(
              "div",
              { staticClass: "control" },
              [
                _c("sundry-creditor-vendor", {
                  attrs: {
                    "is-new": _vm.entity.isNew,
                    "read-only": _vm.readOnly,
                  },
                  on: { vendorChanged: _vm.vendorChanged },
                  model: {
                    value: _vm.entity.vendor,
                    callback: function ($$v) {
                      _vm.$set(_vm.entity, "vendor", $$v)
                    },
                    expression: "entity.vendor",
                  },
                }),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Contact")]),
            _c(
              "div",
              { staticClass: "control" },
              [
                _c("sundry-creditor-vendor-contact", {
                  attrs: {
                    "read-only": _vm.readOnly,
                    vendor: _vm.entity.vendor,
                  },
                  model: {
                    value: _vm.entity.contact,
                    callback: function ($$v) {
                      _vm.$set(_vm.entity, "contact", $$v)
                    },
                    expression: "entity.contact",
                  },
                }),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "field-body" }, [
            _c("div", { staticClass: "field is-narrow" }, [
              _c("label", { staticClass: "label" }, [_vm._v("ABN")]),
              _c(
                "div",
                { staticClass: "control" },
                [
                  !_vm.readOnly && _vm.$company.info.countryCode === "AU"
                    ? _c("the-mask", {
                        ref: "abn",
                        staticClass: "input abn",
                        class: {
                          "is-static": _vm.readOnly,
                          "is-danger": _vm.$v.entity.abn.$error,
                        },
                        attrs: {
                          id: "abn",
                          readonly: _vm.readOnly,
                          name: "abn",
                          placeholder: "## ### ### ###",
                          mask: ["## ### ### ###"],
                        },
                        model: {
                          value: _vm.entity.abn,
                          callback: function ($$v) {
                            _vm.$set(_vm.entity, "abn", $$v)
                          },
                          expression: "entity.abn",
                        },
                      })
                    : _c("div", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.entity.abn,
                              expression: "entity.abn",
                            },
                          ],
                          ref: "abn",
                          staticClass: "input is-uppercase",
                          attrs: {
                            id: "abn",
                            type: "text",
                            maxlength: "12",
                            disabled: _vm.readOnly,
                          },
                          domProps: { value: _vm.entity.abn },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(_vm.entity, "abn", $event.target.value)
                            },
                          },
                        }),
                      ]),
                  _vm.$v.entity && !_vm.$v.entity.abn.minLength
                    ? _c("span", { staticClass: "help is-danger" }, [
                        _vm._v(
                          "ABN must be at least " +
                            _vm._s(_vm.$v.entity.abn.$params.minLength.min) +
                            " letters."
                        ),
                      ])
                    : _vm._e(),
                  _vm.$v.entity &&
                  !_vm.$v.entity.abn.validAbn &&
                  _vm.$v.entity.abn.minLength
                    ? _c("span", { staticClass: "help is-danger" }, [
                        _vm._v("ABN invalid"),
                      ])
                    : _vm._e(),
                  _vm.entity.vendor &&
                  !_vm.entity.abn &&
                  _vm.$company.info.isWithHold
                    ? _c("span", { staticClass: "help is-danger" }, [
                        _vm._v(
                          " This vendor does not have an ABN. You will be required to with hold 49.00% of the invoice. "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("G/L Account")]),
              _vm.readOnly
                ? _c("input", {
                    staticClass: "input is-static",
                    attrs: { readonly: "readonly" },
                    domProps: { value: _vm.entity.glCode.displayName },
                  })
                : _c(
                    "div",
                    { staticClass: "control is-expanded" },
                    [
                      _vm.glAccountListCombo && !_vm.readOnly
                        ? _c("multiselect", {
                            attrs: {
                              options: _vm.glAccountListCombo,
                              placeholder: "Select account",
                              label: "displayName",
                              "track-by": "accountNo",
                              "allow-empty": false,
                            },
                            on: {
                              select: function ($event) {
                                return _vm.glAccountSelected($event)
                              },
                            },
                            model: {
                              value: _vm.entity.glCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.entity, "glCode", $$v)
                              },
                              expression: "entity.glCode",
                            },
                          })
                        : _vm._e(),
                      _vm.readOnly
                        ? _c("input", {
                            staticClass: "input is-static",
                            attrs: { readonly: "readonly" },
                            domProps: { value: _vm.entity.glCode.displayName },
                          })
                        : _vm._e(),
                      !_vm.$v.entity.glCode.required
                        ? _c("span", { staticClass: "help is-danger" }, [
                            _vm._v(" G/L Account is required "),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
            ]),
            _c("div", { staticClass: "field is-narrow" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Exported")]),
              _c(
                "div",
                { staticClass: "pretty p-icon p-curve p-smooth p-bigger" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.entity.exported,
                        expression: "entity.exported",
                      },
                    ],
                    attrs: {
                      id: "chk-invoice-exported",
                      name: "chk-invoice-exported",
                      type: "checkbox",
                      disabled:
                        _vm.readOnlyView || !_vm.$userInfo.isSupportUser,
                    },
                    domProps: {
                      checked: Array.isArray(_vm.entity.exported)
                        ? _vm._i(_vm.entity.exported, null) > -1
                        : _vm.entity.exported,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.entity.exported,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.entity,
                                "exported",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.entity,
                                "exported",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.entity, "exported", $$c)
                        }
                      },
                    },
                  }),
                  _vm._m(0),
                ]
              ),
            ]),
          ]),
          _c("div", { staticClass: "is-divider" }),
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Quote No.")]),
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.entity.quoteNo,
                      expression: "entity.quoteNo",
                    },
                    {
                      name: "fq-validate",
                      rawName: "v-fq-validate",
                      value: _vm.$v.entity.quoteNo,
                      expression: "$v.entity.quoteNo",
                    },
                  ],
                  ref: "name",
                  staticClass: "input quoteNo",
                  class: { "is-static": _vm.readOnly },
                  attrs: { readonly: _vm.readOnly, type: "text" },
                  domProps: { value: _vm.entity.quoteNo },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.entity, "quoteNo", $event.target.value)
                    },
                  },
                }),
                !_vm.$v.entity.quoteNo.isValid
                  ? _c("span", { staticClass: "help is-danger" }, [
                      _vm._v("Quote no. does not exist"),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "column field is-narrow" },
              [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Payment Due Date"),
                ]),
                _vm.readOnly
                  ? _c("div", { staticClass: "control" }, [
                      _c("input", {
                        staticClass: "input is-static",
                        attrs: { readonly: "" },
                        domProps: {
                          value: _vm.$filters.formatDateTimezone(
                            _vm.entity.due,
                            _vm.$userInfo.locale
                          ),
                        },
                      }),
                    ])
                  : _c("v-date-picker", {
                      attrs: {
                        "is-dark": _vm.$theme.isDark,
                        masks: _vm.formats,
                        attributes: _vm.attrs,
                        locale: _vm.$userInfo.locale,
                        timezone: _vm.$filters.getIanaTimezone(),
                      },
                      on: {
                        input: function ($event) {
                          _vm.selectedDueDate = $event
                            ? _vm.$filters.fromISOWithCurrentTime(
                                $event.toISOString()
                              )
                            : null
                        },
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ inputValue, inputEvents }) {
                            return [
                              _c("div", { staticClass: "field" }, [
                                _c(
                                  "div",
                                  { staticClass: "control has-icons-left" },
                                  [
                                    _c(
                                      "input",
                                      _vm._g(
                                        {
                                          staticClass: "input",
                                          attrs: {
                                            type: "text",
                                            placeholder: "Date To...",
                                            readonly: "",
                                          },
                                          domProps: { value: inputValue },
                                        },
                                        inputEvents
                                      )
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "icon is-small is-left" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-calendar mdi-18px",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.selectedDueDate,
                        callback: function ($$v) {
                          _vm.selectedDueDate = $$v
                        },
                        expression: "selectedDueDate",
                      },
                    }),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "is-divider" }),
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Capital")]),
              !_vm.readOnly
                ? _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.entity.isCapital,
                          expression: "entity.isCapital",
                        },
                      ],
                      staticClass: "switch is-rounded",
                      attrs: {
                        id: "capital",
                        name: "capital",
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.entity.isCapital)
                          ? _vm._i(_vm.entity.isCapital, null) > -1
                          : _vm.entity.isCapital,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.entity.isCapital,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.entity,
                                  "isCapital",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.entity,
                                  "isCapital",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.entity, "isCapital", $$c)
                          }
                        },
                      },
                    }),
                    _c("label", { attrs: { for: "capital" } }),
                  ])
                : _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.entity.isCapital,
                          expression: "entity.isCapital",
                        },
                      ],
                      staticClass: "switch is-rounded",
                      attrs: {
                        id: "capital",
                        name: "capital",
                        type: "checkbox",
                        disabled: true,
                      },
                      domProps: {
                        checked: Array.isArray(_vm.entity.isCapital)
                          ? _vm._i(_vm.entity.isCapital, null) > -1
                          : _vm.entity.isCapital,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.entity.isCapital,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.entity,
                                  "isCapital",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.entity,
                                  "isCapital",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.entity, "isCapital", $$c)
                          }
                        },
                      },
                    }),
                    _c("label", { attrs: { for: "capital" } }),
                  ]),
            ]),
            _c("div", { staticClass: "column field" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Include in GST report"),
              ]),
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.entity.isIncludeGst,
                      expression: "entity.isIncludeGst",
                    },
                  ],
                  staticClass: "switch is-rounded",
                  attrs: {
                    id: "includeInGst",
                    disabled: true,
                    name: "includeGst",
                    type: "checkbox",
                  },
                  domProps: {
                    checked: Array.isArray(_vm.entity.isIncludeGst)
                      ? _vm._i(_vm.entity.isIncludeGst, null) > -1
                      : _vm.entity.isIncludeGst,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.entity.isIncludeGst,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.entity,
                              "isIncludeGst",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.entity,
                              "isIncludeGst",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.entity, "isIncludeGst", $$c)
                      }
                    },
                  },
                }),
                _c("label", { attrs: { for: "includeInGst" } }),
              ]),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "tile is-parent is-half" }, [
        _c("article", { staticClass: "tile is-child box" }, [
          _c("div", { staticClass: "columns is-gapless" }, [
            _vm._m(1),
            _c("div", { staticClass: "column" }, [
              !_vm.readOnly
                ? _c("div", { staticClass: "control is-pulled-right" }, [
                    _c(
                      "a",
                      {
                        staticClass: "button tooltip is-success",
                        attrs: {
                          "data-tooltip": _vm.addMoreGlDisabled
                            ? "Please enter Invoice No."
                            : "Add Invoice Items",
                          disabled: _vm.addMoreGlDisabled,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.addMoreGlItem()
                          },
                        },
                      },
                      [_vm._m(2), _c("span", [_vm._v("Invoice Items")])]
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
          _c("label", { staticClass: "label" }, [_vm._v("Items")]),
          _c(
            "table",
            {
              staticClass:
                "table is-bordered is-striped is-narrow is-fullwidth",
            },
            [
              _vm._m(3),
              _vm.entity.items.length > 0
                ? _c(
                    "tbody",
                    _vm._l(_vm.entity.items, function (item) {
                      return _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !item.isDeleted,
                              expression: "!item.isDeleted",
                            },
                          ],
                          key: item.id,
                        },
                        [
                          _c("td", [_vm._v(" " + _vm._s(item.itemDesc) + " ")]),
                          _c("td", { staticClass: "has-text-right" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$filters.formatNumber(
                                    item.amountIncGst,
                                    _vm.$userInfo.locale
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  )
                : _c("tbody", [_vm._m(4)]),
              _c("tfoot", { staticClass: "has-multiple-totals no-border" }, [
                _c(
                  "tr",
                  {
                    staticClass: "has-border-bottom-4",
                    class: `sundry-creditor-background-text-${_vm.$theme.name}`,
                  },
                  [
                    _vm._m(5),
                    _c("th", { staticClass: "has-text-right" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            _vm.entity.amount,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
                  ]
                ),
                _c(
                  "tr",
                  {
                    staticClass: "has-border-bottom-4",
                    class: `sundry-creditor-background-primary-${_vm.$theme.name}`,
                  },
                  [
                    _c("th", { staticClass: "has-text-left" }, [
                      _vm._v("GST "),
                      _c("span", { staticClass: "subtext" }, [
                        _vm._v("(" + _vm._s(_vm.entity.gstRate) + "%)"),
                      ]),
                    ]),
                    _c("th", { staticClass: "has-text-right" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            _vm.entity.gstAmount,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
                  ]
                ),
                _c(
                  "tr",
                  {
                    class: `sundry-creditor-background-success-${_vm.$theme.name}`,
                  },
                  [
                    _vm._m(6),
                    _c("th", { staticClass: "has-text-right" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            _vm.entity.totalAmount,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
          _c("label", { staticClass: "label" }, [_vm._v("Payments")]),
          _c(
            "table",
            {
              staticClass:
                "table is-bordered is-striped is-narrow is-fullwidth",
            },
            [
              _vm._m(7),
              _vm.entity.payments.length > 0
                ? _c(
                    "tbody",
                    _vm._l(_vm.entity.payments, function (item) {
                      return _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !item.isDeleted,
                              expression: "!item.isDeleted",
                            },
                          ],
                          key: item.id,
                        },
                        [
                          _c("td", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$filters.formatDateTimezone(
                                    item.payDate,
                                    _vm.$userInfo.locale
                                  )
                                ) +
                                " "
                            ),
                          ]),
                          _c("td", [_vm._v(" " + _vm._s(item.cheque) + " ")]),
                          _c("td", { staticClass: "has-text-right" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$filters.formatNumber(
                                    item.paid,
                                    _vm.$userInfo.locale
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  )
                : _c("tbody", [_vm._m(8)]),
              _c("tfoot", { staticClass: "has-multiple-totals" }, [
                _c("tr", [
                  _c(
                    "th",
                    { staticClass: "has-text-right", attrs: { colspan: "2" } },
                    [_vm._v("Total Paid")]
                  ),
                  _c("th", { staticClass: "has-text-right has-text-success" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatCurrency(
                          _vm.totalPaid,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]),
                ]),
                _c("tr", [
                  _c(
                    "th",
                    { staticClass: "has-text-right", attrs: { colspan: "2" } },
                    [_vm._v("Balance")]
                  ),
                  _c("th", { staticClass: "has-text-right has-text-success" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatCurrency(
                          _vm.entity.totalAmount - _vm.totalPaid,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label", [_vm._v("Exported")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Summary")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-18px mdi-plus" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Description")]),
        _c("th", { staticClass: "has-text-right" }, [_vm._v(" Total ")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "has-text-centered", attrs: { colspan: "2" } }, [
        _c("span", { attrs: { icon: "icon is-medium" } }, [
          _c("i", {
            staticClass:
              "mdi mdi-36px mdi-dots-horizontal mdi-inactive-color mdi-inactive",
          }),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("th", { staticClass: "has-text-left" }, [
      _vm._v("Total "),
      _c("span", { staticClass: "subtext" }, [_vm._v("(Ex GST)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("th", { staticClass: "has-text-left" }, [
      _vm._v("Total "),
      _c("span", { staticClass: "subtext" }, [_vm._v("(Inc GST)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Date")]),
        _c("th", [_vm._v("Cheque No.")]),
        _c("th", { staticClass: "has-text-right" }, [_vm._v(" Paid ")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "has-text-centered", attrs: { colspan: "3" } }, [
        _c("span", { attrs: { icon: "icon is-medium" } }, [
          _c("i", {
            staticClass:
              "mdi mdi-36px mdi-dots-horizontal mdi-inactive-color mdi-inactive",
          }),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }